function CopyIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 6.67252C2 4.09196 4.0936 2 6.67619 2H12.3794C12.7163 2 12.9893 2.27286 12.9893 2.60946C12.9893 2.94605 12.7163 3.21892 12.3794 3.21892H6.67619C4.76732 3.21892 3.21988 4.76515 3.21988 6.67252V12.4476C3.21988 12.7842 2.9468 13.0571 2.60994 13.0571C2.27308 13.0571 2 12.7842 2 12.4476V6.67252Z"
        fill="#303757"
        fillOpacity="0.6"
      />
      <path
        d="M14.3228 4.87929C11.6871 4.58495 8.98454 4.58495 6.34884 4.87929C5.59798 4.96315 4.9946 5.55359 4.9061 6.30967C4.5935 8.9803 4.5935 11.6782 4.9061 14.3489C4.9946 15.1049 5.59798 15.6954 6.34884 15.7792C8.98454 16.0736 11.6871 16.0736 14.3228 15.7792C15.0737 15.6954 15.677 15.1049 15.7655 14.3489C16.0781 11.6782 16.0781 8.9803 15.7655 6.30967C15.677 5.55359 15.0737 4.96315 14.3228 4.87929Z"
        fill="#303757"
        fillOpacity="0.6"
      />
    </svg>
  );
}

export default CopyIcon;
